import { render, staticRenderFns } from "./BulletinBoardMessageForm.vue?vue&type=template&id=8484199c&scoped=true&"
import script from "./BulletinBoardMessageForm.vue?vue&type=script&lang=js&"
export * from "./BulletinBoardMessageForm.vue?vue&type=script&lang=js&"
import style0 from "./BulletinBoardMessageForm.vue?vue&type=style&index=0&id=8484199c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8484199c",
  null
  
)

export default component.exports